import Vue from 'vue'
import VueMoment from 'vue-moment'
import firebase from 'firebase'
import App from './App.vue'
import store from './store'
import router from './router'

Vue.config.productionTip = false

Vue.use(VueMoment)
Vue.init = false

new Vue({
  store,
  router,
  render: h => h(App),
  created () {
    // Check initial auth state, this fires once whether we're signed out or
    // able to retain an existing session - only then should we mount the app to
    // avoid misleading login redirects
    firebase.auth()
      .onAuthStateChanged(async () => {
        const user = firebase.auth().currentUser

        if (user === null) {
          this.$store.dispatch('logout')
          // this.$router.push('/login')
        } else {
          const { claims } = await user.getIdTokenResult()
          console.log({ claims })
          await this.$store.dispatch('login', claims.userId)
        }

        if (!Vue.init) {
          this.$mount('#app')
          Vue.init = true
        }
      })
  }
})
